// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 9.10923V2H11V9.10924L8.49191 6.62966L7.08581 8.05194L12 12.9103L16.9142 8.05193L15.5081 6.62966L13 9.10923Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9 2.00008H2V22.0001H22V2.00008H15V4.00008H20V14.0001H4V4.00008H9V2.00008ZM8.00195 16.998V19.002H5.99805V16.998H8.00195ZM11.002 16.998V19.002H8.99805V16.998H11.002Z"}}]};

const InstallFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'install-filled',
    ref,
    icon: element,
  },
));

InstallFilledIcon.displayName = 'InstallFilledIcon';

export default InstallFilledIcon;
